export const createRequesterMediator = (config) => {
    return (signal) => {
        let { signalHandler } = config;

        signal.add(signalHandler);

        return {
            destroy() {
                signal.remove(signalHandler);
            }
        };
    };
};
